import { parse, relative } from 'path';

// @ts-ignore - error TS7016: Could not find a declaration file for module '@parcel/hash'
// This was added after enrolling @atlassian/parcel-transformer-react-async into JFE local consumption
// TODO Replace this ts-ignore with a proper solution
import { hashString } from '@parcel/hash';
import { Transformer } from '@parcel/plugin';

import {
	transform as reactTransformer,
	type TransformOptions,
} from '@atlassian/react-async-transformer';

type PackageJsonReactAsync = {
	transformer?: Omit<TransformOptions, 'getModuleId' | 'source'>;
};

type Module = {
	moduleId: string;
	moduleName?: string;
};

// 2-term humpCase / HumpCase
const meaningfulFileNameRegex = /^[a-zA-Z0-9]+[A-Z][a-zA-Z0-9]*$/;

// eslint-disable-next-line import/no-anonymous-default-export
export default new Transformer({
	async loadConfig({ config, options: { projectRoot } }) {
		const { contents = {} } =
			(await config.getConfigFrom<PackageJsonReactAsync>(projectRoot + '/index', [], {
				packageKey: 'react-async',
			})) ?? {};

		return contents?.transformer ?? {};
	},

	async transform({ asset, config, options: { projectRoot }, resolve }) {
		const source = await asset.getCode();
		const transformation = reactTransformer({
			...config,
			async getModule(request) {
				const abs = await resolve(asset.filePath, request);
				const rel = relative(projectRoot, abs);
				const { name } = parse(rel);

				const module: Module = {
					moduleId: hashString(rel).slice(-8),
				};

				if (meaningfulFileNameRegex.test(name)) {
					module.moduleName = name;
				}

				return module;
			},
			source,
		});

		const {
			code,
			meta: { jsResources },
		} = await transformation;

		if (code !== source) {
			asset.setCode(code);
		}

		if (jsResources.length) {
			asset.meta.jsResources = jsResources;
		}

		return [asset];
	},
});
